export enum CurrentLifeInsurance {
  EMMA = 'YES_EMMA',
  YES = 'YES',
  NO = 'NO',
}

export enum ReplaceInsurance {
  YES = 'YES',
  NO = 'NO',
  UNKNOWN = 'UNKNOWN',
}

export function isReplacingInsurance(replaceInsurance: ReplaceInsurance): boolean {
  return replaceInsurance === ReplaceInsurance.YES || replaceInsurance === ReplaceInsurance.UNKNOWN;
}
